import React, {Fragment} from 'react'
import {Button} from "react-bootstrap";
import {AUDIO_FILES} from "../constants";
import * as Icon from 'react-bootstrap-icons';
import * as Fa from 'react-icons/fa';

class Sound extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            audio: '',
            play_on: 0
        };
    }

    playAudio = (e) => {
        console.log(e.currentTarget.id,this.state.play_on);
        //this.setState(state => ({audio: new Audio(AUDIO_FILES[e.currentTarget.id])}));
        let audio = new Audio(AUDIO_FILES[e.currentTarget.id]);
        this.setState(state => ({audio: audio}));
        audio.addEventListener('ended', () => {
            this.setState(state => ({play_on: 0}));
        })
        if(this.state.play_on === 0) {
            this.setState(state => ({play_on: 1}));
            let playPromise =
                audio.play()
            //this.setState(state => ({play_on: 0}));
            if (playPromise !== undefined) {
                playPromise.then(_ => {
                    //console.log(audio);
                    // Automatic playback started!
                    // Show playing UI.
                    // We can now safely pause video...
                    //this.state.audio.pause();

                })
                    .catch(error => {
                        console.log(playPromise);
                    });
            }
            else {
                audio.load();
                audio.play().then(r => {
                    this.setState(state => ({play_on: 0}));
                });
            }
        }
    }

    stopAudio = () => {
        this.state.audio.pause();
        //this.state.audio.currentTime = 0;
        this.setState(state => ({play_on: 0}));
    }


    render() {
        return (
            <Fragment>
            <div className="item_block">
                <p>Отрицательная реакция</p>

                <Button className="klein_text" variant="secondary" size="lg" id={'1'}
                        onClick={this.state.play_on === 0 ? this.playAudio : this.stopAudio}
                >
                Не смешите меня
                </Button>

                <Button className="klein_text" variant="secondary" size="lg" id={'0'}
                        onClick={this.state.play_on === 0 ? this.playAudio : this.stopAudio}
                        >
                Это не серьёзно
                </Button>
            </div>
            <div className="item_block">
                <p>Предложение</p>
                <Button className="klein_text" variant="secondary" size="lg" id={'4'}
                        onClick={this.state.play_on === 0 ? this.playAudio : this.stopAudio}
                >
                Хорошо бы выпить
                </Button>
            </div>
            <div className="item_block">
                <p>Хватит, надоело</p>
                <Button className="klein_text" variant="secondary" size="lg" id={'2'}
                        onClick={this.state.play_on === 0 ? this.playAudio : this.stopAudio}
                >
                Хватит, надоело
                </Button>
                <Button className="klein_text" variant="secondary" size="lg" id={'5'}
                        onClick={this.state.play_on === 0 ? this.playAudio : this.stopAudio}
                >
                    Ну и хрен с ним
                </Button>
            </div>
            <div className="item_block">
                <p>Ещё хуже</p>
                <Button className="klein_text" variant="secondary" size="lg" id={'3'}
                        onClick={this.state.play_on === 0 ? this.playAudio : this.stopAudio}
                >
                Когда чешутся
                </Button>
            </div>
            </Fragment>
        );
    }
}

export default Sound;
